import { render, staticRenderFns } from "./notification-view.vue?vue&type=template&id=41eeceb4&scoped=true&lang=pug"
import script from "./notification-view.js?vue&type=script&lang=js&external"
export * from "./notification-view.js?vue&type=script&lang=js&external"
import style0 from "./notification-view.vue?vue&type=style&index=0&id=41eeceb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41eeceb4",
  null
  
)

export default component.exports